import { render, staticRenderFns } from "./CharacterItem.vue?vue&type=template&id=2db91ea9&scoped=true&"
import script from "./CharacterItem.vue?vue&type=script&lang=ts&"
export * from "./CharacterItem.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterItem.vue?vue&type=style&index=0&id=2db91ea9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db91ea9",
  null
  
)

export default component.exports